<template>
	<router-view />
</template>

<script>
import "@/styles/styles.scss";
import Vue from "vue";
import Fragment from "vue-fragment";
import axios from "axios";
import VueCurrencyInput from "vue-currency-input";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.use(Fragment.Plugin);

Vue.use(VueCurrencyInput);

export default {
	name: "App",

	components: {},

	data: () => ({}),
};
</script>
